module.exports = __webpack_public_path__ + "static/img/Ringoo.0e83afa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Ringoo.png
// module id = iw27
// module chunks = 0